import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = {
  id: "ranksCarousel",
  class: "card-body text-center d-flex align-items-strech carousel carousel-dark slide"
}
const _hoisted_4 = { class: "carousel-inner rank-carousel-inner" }
const _hoisted_5 = { class: "text-dark mt-0 mb-2 rank-name" }
const _hoisted_6 = { class: "fa-stack rank-icon fa-4x" }
const _hoisted_7 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('fas fa-lock fa-stack-1x rank-locked')
}
const _hoisted_8 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass('fas fa-check-circle fa-stack-1x rank-unlocked text-green')
}
const _hoisted_9 = {
  key: 2,
  class: "rank-current-dot",
  title: "Rango actual",
  "aria-label": "Rango actual"
}
const _hoisted_10 = { class: "text-dark d-block mt-3" }
const _hoisted_11 = {
  key: 0,
  class: "rank-date"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = {
  key: 2,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, [
      _createElementVNode("span", null, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-tasks me-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.cardTitle), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, { name: _ctx.slideDir }, {
          default: _withCtx(() => [
            (_ctx.activeRank)
              ? (_openBlock(), _createElementBlock("div", {
                  key: _ctx.displayedRankId,
                  class: "rank-slide"
                }, [
                  _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.activeRank.name), 1),
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "rank-svg-stack",
                      style: _normalizeStyle({ color: _ctx.rankColorVar(_ctx.activeRank._id) })
                    }, [
                      _createVNode(_component_rank_icon, {
                        "icon-class": _ctx.activeRank.iconClass,
                        "extra-class": "rank-svg rank-base"
                      }, null, 8, ["icon-class"]),
                      (_ctx.nextRank != undefined)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "rank-svg-clip",
                            style: _normalizeStyle([
                    _ctx.isNextRank(_ctx.activeRank._id)
                      ? { height: 100 - _ctx.nextRank.progress + '%' }
                      : _ctx.isRankLocked(_ctx.activeRank._id)
                      ? { height: 100 + '%' }
                      : { height: '0%' },
                  ])
                          }, [
                            _createVNode(_component_rank_icon, {
                              "icon-class": _ctx.activeRank.iconClass,
                              "extra-class": "rank-svg rank-progress"
                            }, null, 8, ["icon-class"])
                          ], 4))
                        : _createCommentVNode("", true)
                    ], 4),
                    (_ctx.isRankLocked(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                      : _createCommentVNode("", true),
                    (_ctx.isRankUnlocked(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                      : _createCommentVNode("", true),
                    (_ctx.isCurrentRank(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    (_ctx.rankDate(_ctx.activeRank._id) && !_ctx.isNextRank(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatDateTimezone(_ctx.rankDate(_ctx.activeRank._id))), 1))
                      : _createCommentVNode("", true),
                    (_ctx.nextRank != undefined && _ctx.isNextRank(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _cache[3] || (_cache[3] = _createTextVNode(" Avance: ", -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.toTwoDecimals(_ctx.nextRank.progress)) + " % ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isRankLocked(_ctx.activeRank._id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Rango Bloqueado"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _createElementVNode("a", {
        class: _normalizeClass(["carousel-control-prev", { disabled: _ctx.atStart }]),
        href: "#ranksCarousel",
        role: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.slidePrev && _ctx.slidePrev(...args)), ["prevent"]))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", {
          class: "carousel-control-prev-icon",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
      ]))], 2),
      _createElementVNode("a", {
        class: _normalizeClass(["carousel-control-next", { disabled: _ctx.atEnd }]),
        href: "#ranksCarousel",
        role: "button",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.slideNext && _ctx.slideNext(...args)), ["prevent"]))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("span", {
          class: "carousel-control-next-icon",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
      ]))], 2)
    ])
  ]))
}